export const toTitleCase = (word: string) => {
  if (!word || typeof word !== 'string') {
    return word;
  }
  const lowerCasedWord = word.toLowerCase();
  return lowerCasedWord.replace(lowerCasedWord[0], lowerCasedWord[0].toUpperCase());
};
